/** Estados en los que aún se puede registrar un pago en la venta. */
export function canProcessSalesOrderPayment(status: string): boolean {
  return !['PAID', 'CANCELLED', 'REFUNDED'].includes(status);
}

/**
 * Estados en los que se puede actualizar la entrega al cliente (handoff).
 * Aligns with backend `updateItemDelivery` / `markAsDelivered` guards.
 *
 * LP: Intentional — PARTIAL_PAID allowed (delivery ≠ full settlement).
 * Blocked when delivery was voided by a full return (`CANCELLED`).
 */
export function canUpdateSalesOrderDelivery(
  status: string,
  deliveryStatus?: string | null,
): boolean {
  if (deliveryStatus === 'CANCELLED') return false;
  return ['PAID', 'PARTIAL_PAID', 'DELIVERED'].includes(status);
}

/** Legacy pre-migration fulfillment value — treat like COMPLETED until DB is clean. */
function isFulfillmentClosedForExchange(fulfillment: string): boolean {
  return fulfillment === 'NOT_REQUIRED' || fulfillment === 'COMPLETED' || fulfillment === 'READY';
}

/**
 * Whether the exchange action should be shown / allowed.
 * Mixed sales (`PENDING` / `FAILED` / `CANCELLED`) block until logistics are closed.
 * Local-only (`NOT_REQUIRED`) and completed mixed sales are allowed when
 * payment status is eligible. Full-return voided delivery blocks exchange.
 */
export function canExchangeSalesOrder(
  status: string,
  fulfillmentStatus?: string | null,
  deliveryStatus?: string | null,
): boolean {
  const hasValidStatus = ['PAID', 'DELIVERED', 'PARTIAL_PAID'].includes(status);
  if (!hasValidStatus) return false;
  if (deliveryStatus === 'CANCELLED') return false;

  const fulfillment = fulfillmentStatus ?? 'NOT_REQUIRED';
  return isFulfillmentClosedForExchange(fulfillment);
}
